import axios from 'axios';
import {AxiosWebApiClient} from '@/core/webapi/WebApiClient';
import {WebFormModel} from "capitalist-shared/src/core/model";
import {Authenticator} from '@/core/auth/Auth';
import {RemoteRequestState} from '@/backoffice/components/pages/taxrules/taxrules';

export class GooglecodeModel extends WebFormModel {
  auth: Authenticator;

  values: {
    username: string
    code: string
    token: string
    oauth: boolean
  } = {
    username: '',
    code: '',
    token: '',
    oauth: false
  }

  defaultOptions = {tokenUpdateRequired: false, nextToken: '', captchaRequired: false}
  options = {tokenUpdateRequired: false, nextToken: '', captchaRequired: false}

  submitStatus: RemoteRequestState = new RemoteRequestState();

  constructor(model?: any, client?: AxiosWebApiClient) {
    super(model);
    this.auth = new Authenticator(client);
  }

  submit() {
    this.errors.clear();
    this.submitStatus.loadStart();
    return this.auth.google2fa(this.values.username,
      this.values.token, this.values.code, this.values.oauth).then((result) => {
      this.submitStatus.loadEnd();
      return result;
    }).catch((err) => {
      this.submitStatus.loadError();
      this.checkAxiosError(err);
      if (this.options.nextToken) {
        this.values.token = this.options.nextToken;
      }
      throw err;
    });
  }

  checkAxiosError(axiosError) {
    if (axiosError && (typeof axiosError === 'object')
      && axiosError.response
      && axiosError.response.status) {
      if (axiosError.response.status == 422) {
        this.errors.setErrors(axiosError.response.data.model.errors);
        this.options = Object.assign({}, this.defaultOptions, axiosError.response.data.model.options);
      } else if (axiosError.response.status == 449) {
        this.errors.setErrors(axiosError.response.data.model.errors);
        this.options = Object.assign({}, this.defaultOptions, axiosError.response.data.model.options);
      } else {
        this.errors.set('http', `Response Status ${axiosError.response.status}`);
      }
    }
  }
}

export default class AuthModel extends WebFormModel {
  auth: Authenticator;

  submitStatus: RemoteRequestState = new RemoteRequestState();

  values = {username: '', password: '', captchaCode: '', oauth: false}

  defaultOptions = {isCaptchaRequired: false, isGooglecodeRequired: false, nextToken: ''}

  options = {isCaptchaRequired: false, isGooglecodeRequired: false, nextToken: ''}

  async getModel() {
    return axios.post('/webapi/auth/login', {
      call: 'getModel',
    }).then((result) => result.data.model);
  }

  constructor(model?: any, client?: AxiosWebApiClient) {
    super(model);
    this.auth = new Authenticator(client);
  }

  submit() {
    this.errors.clear();
    this.submitStatus.loadStart();

    // return this.getModel().then((model: any) => {
    //     this.options.isCaptchaRequired = model.options.isCaptchaRequired
    // }).then(() => {
    //
    //     return this.auth.login(''+this.values.username,
    //         ''+this.values.password, this.values.captchaCode).then((result) => {
    //         this.authing.loadEnd();
    //         return result;
    //     }).catch((err) => {
    //         this.authing.loadError();
    //         this.checkAxiosError(err);
    //         throw err;
    //     });
    //
    // });

    return this.auth.login(
      `${this.values.username}`,
      `${this.values.password}`,
        this.values.captchaCode,
        null, null, this.values.oauth).then((result) => {
      this.submitStatus.loadEnd();
      return result;
    }).catch((err) => {
      this.submitStatus.loadError();
      if (err == 'Failed to get attributes.') this.errors.set('username', 'Failed to get attributes.');
      this.checkAxiosError(err);
      this.options.isCaptchaRequired = this.options.isCaptchaRequired || this.errors.has('captchaCode');
      throw err;
    });
  }

  checkAxiosError(axiosError) {
    if (axiosError && (typeof axiosError === 'object')
      && axiosError.response
      && axiosError.response.status) {
      if (axiosError.response.status == 422) {
        this.errors.setErrors(axiosError.response.data.model.errors);
        this.options = Object.assign({}, this.defaultOptions, axiosError.response.data.model.options);
      } else if (axiosError.response.status == 449) {
        this.errors.setErrors(axiosError.response.data.model.errors);
        this.options = Object.assign({}, this.defaultOptions, axiosError.response.data.model.options);
      } else {
        this.errors.set('http', `Response Status ${axiosError.response.status}`);
      }
    }
  }
}
